// extracted by mini-css-extract-plugin
export var aiStarIcon = "_aq-4";
export var closeButton = "_aq-6";
export var dismissButton = "_aq-3";
export var editImageWithAiContainer = "_aq-8";
export var imageUploadWrapper = "_aq-7";
export var misspelledWord = "_aq-5";
export var spellCheckContainer = "_aq-2";
export var spin = "_aq-1";
export var spinning = "_aq-0";